import React, {useEffect, useRef, useState} from 'react';
import {withRouter} from 'react-router';
import {deleteAPI, getAPI, postAPI, putAPI} from "../../APIUtil";
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import {Card, Col, Container, Form, InputGroup, Row} from "react-bootstrap";
import {
  parseDate,
  setFocusCalendar,
  dateformatDB,
} from "../../CMUtil";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";

export const PayDateDialog = ({pPayDate, pOnClickSelectPayDate}) => {

  const iniPayDateMonth = useRef(true);
  const [dispCount, setDispCount] = useState(1);

  // 基準日ダイアログ
  const [payDateMonth, setPayDateMonth] = useState("");
  const [payDateList, setPayDateList] = useState([]);

  // 初期化
  useEffect(() => {
    const init = async () => {
      let cPayDateMonth = null;
      if(pPayDate){
        cPayDateMonth = new Date(pPayDate.getTime());
      }else{
        cPayDateMonth = new Date();
      }
      cPayDateMonth.setDate(1);
      setPayDateMonth(cPayDateMonth);
    }
    init();
  }, []);

  useEffect(() => {
    if (iniPayDateMonth.current) {
      iniPayDateMonth.current = false;
      return;
    }

    const update = async () => {
      let cList = [];
      let payDateMonthEnd = new Date(payDateMonth.getTime());
      payDateMonthEnd.setMonth(payDateMonth.getMonth() + 1);

      let searchCondition = {
        pay_date_from: dateformatDB(payDateMonth),
        pay_date_to: dateformatDB(payDateMonthEnd)
      };
      let res = await getAPI("ms_pay_date/", searchCondition);
      if(res.count > 0){
        cList = res.results;
      }

      let hasEmptyRow = false;
      cList.forEach((payDate) => {
        if (!payDate.pay_date) {
          hasEmptyRow = true;
        }
      });

      if (!hasEmptyRow) {
        //空行の追加
        cList.push({
          pay_date_id: "",
          pay_date: "",
          remark: ""
        });
        setPayDateList(cList);
      }
    }
    update();
  }, [payDateMonth, dispCount]);

  const onClickSavePayDate = async () => {
    let cList = payDateList;
    cList = await modalBulkPayDateSave(cList);
    setPayDateList(cList);
    setDispCount(dispCount + 1);
  }

  const modalBulkPayDateSave = async (payDatelist) => {
    let cList = [];
    for (let i = 0; i < payDatelist.length; i++) {
      let obj = payDatelist[i];
      if (!obj.pay_date_id) {
        if (!obj.pay_date) {
          // 日付なしはスキップ
          continue;
        }
        //登録
        obj = await postAPI("ms_pay_date/", obj);
      } else {
        //更新
        obj = await putAPI("ms_pay_date/" + obj.pay_date_id + "/", obj);
      }
      cList.push(obj);
    }
    return cList;
  }

  const onClickDeletePayDate = async(index) => {
    await deleteAPI("ms_pay_date/" + payDateList[index].pay_date_id + "/", payDateList[index]);
    setDispCount(dispCount + 1);
  }

  const onClickSelectPayDate = (index) => {
    pOnClickSelectPayDate(parseDate(payDateList[index].pay_date));
  }

  const setNewPayDate = (date, index) => {
      let clist = JSON.parse(JSON.stringify(payDateList));
      clist[index].pay_date = dateformatDB(date);
      setPayDateList(clist);
  }

  const setNewRemark = (remark, index) => {
      let clist = JSON.parse(JSON.stringify(payDateList));
      clist[index].remark = remark;
      setPayDateList(clist);
  }

  return (
    <>
      <Card className="card-search">
        <Container>
          <Row>
            <Col sm={3}/>
            <Col sm={6} className="input-group mb-3">
              <DatePicker
                id="payDateMonth"
                selected={payDateMonth}
                onChange={(date) => setPayDateMonth(date)}
                dateFormat="yyyy年MM月"
                showMonthYearPicker
                locale="ja"/>
              <Button
                variant="link"
                style={{paddingRight: "0"}}
                onClick={e => setFocusCalendar(e, 'payDateMonth')}>
                <FontAwesomeIcon icon={faCalendarAlt} size="2x"/>
              </Button>
            </Col>
            <Col sm={3}/>
          </Row>
          <Row className="tbl-h-00 mb-1" style={{marginBottom: ".2rem", borderTop: "1px solid #ced4da"}}>
            <Col sm={2} className="tbl-h-00-start form-label">選択</Col>
            <Col sm={3} className="tbl-h-00 form-labe">基準日</Col>
            <Col sm={6} className="tbl-h-00 form-labe">備考</Col>
            <Col sm={1} className="tbl-h-00 form-labe">削除</Col>
          </Row>
          {payDateList.map((payDate, index) => (
            <Row key={index} className="mb-1">
              <Col sm={2} className="pl-1 pr-1 text-center">
                {payDate.pay_date_id &&
                  <Button
                    variant="primary"
                    onClick={e => onClickSelectPayDate(index)}
                    style={{padding: ".2rem", width: "96%"}}>
                    選択
                  </Button>
                }
              </Col>
              <Col sm={3} className="input-group pl-1 pr-1">
                <DatePicker
                  id={"payDate_" + index}
                  selected={parseDate(payDate.pay_date)}
                  onChange={(date) => setNewPayDate(date, index)}
                  dateFormat="yyyy年MM月dd日"
                  locale="ja"
                />
              </Col>
              <Col sm={6} className="input-group pl-1 pr-1">
                <Form.Control type="text" value={payDate.remark} onChange={e => setNewRemark(e.target.value, index)}/>
              </Col>
              <Col sm={1} className="input-group pl-1 pr-1">
                {payDate.pay_date_id &&
                  <Button
                    variant="tertiary"
                    onClick={e => onClickDeletePayDate(index)}
                    style={{padding: ".2rem", width: "96%"}}>
                    削除
                  </Button>
                }
              </Col>
            </Row>
          ))}
          <Row style={{width: "100%"}}>
            <Col className="text-left">
            </Col>
            <Col className="text-right">
              <Button variant="primary" onClick={e => onClickSavePayDate()}>
                登録
              </Button>
            </Col>
          </Row>
        </Container>
      </Card>
    </>
  );
}

export default withRouter(PayDateDialog);